import React, {useState} from "react";
import ImplementationDegradation from "./implementation_degradation";
import ImplementationBiosensor from "./implementation_biosensor";

export default function Implementation() {


    const [isBiosensor, setIsBiosensor] = useState(true);

    const switchPage = () => {
        setIsBiosensor(!isBiosensor);
    };

    if (isBiosensor)
        return <ImplementationBiosensor switchPage={() => switchPage()}/>
    else
        return <ImplementationDegradation switchPage={() => switchPage()}/>

}